<template>
  <header>
    <div class="d-flex d-md-none">
    <v-navigation-drawer
        v-model="drawer"
        app
        overlay-color="#000"
        overlay-opacity="0.8"
        :disable-resize-watcher="true"
        :disable-route-watcher="true"
        :floating="true"
    >
        <v-list-item>
            <v-list-item-content>
            <v-list-item-title class="title">
              <router-link
                  link to="/"
                  v-on:click.native="CloseDrawer()"
              >
                  <img src="img/logo.png" alt="logo" class="nav_logo">
              </router-link>
            </v-list-item-title>
            <v-list-item-subtitle>
                <div style="text-align:center">Suzuka Hisamatsu Exhibition</div>
            </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
            <p></p>

        <v-list
            nav
        >
            <v-list-item
            link
            >
            <v-list-item-content>
                <v-list-item-title>
                <router-link link to="/works"
                  v-on:click.native="CloseDrawer()"
                >
                  <div style="text-align:center;color:#333333">Works</div>
                </router-link>
                </v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item
            link
            >
            <v-list-item-content>
                <v-list-item-title>
                <router-link link to="/video"
                  v-on:click.native="CloseDrawer()"
                >
                  <div style="text-align:center;color:#333333">Video</div>
                </router-link>
                </v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            <v-list-item
            link
            >
            <v-list-item-content>
                <v-list-item-title>
                <router-link link to="/information"
                  v-on:click.native="CloseDrawer()"
                >
                  <div style="text-align:center;color:#333333">Information</div>
                </router-link>
                </v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            </v-list>
            <p></p>
              <div style="text-align:center">
                <v-btn text @click="Localetoja"
                :class="{ 'local_active': CheckLocale('ja') }">
                JP
                </v-btn>
                <v-btn text @click="Localetoen"
                :class="{ 'local_active': !CheckLocale('ja') }">
                EN
                </v-btn>
              </div>
          </v-navigation-drawer>
    </div>
    <v-app-bar
    flat
    color="rgba(255,255,255,0.8)"
    :height="100"
    app
    hide-on-scroll
    >
        <v-btn icon class="d-flex d-md-none" @click.stop="drawer = !drawer" style="margin-left:0px;">
        <div id="humberger">
          <div></div>
          <div></div>
          <div></div>
        </div>
        </v-btn>
        <!-- <v-app-bar-nav-icon class="d-flex d-md-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
        <v-spacer class="d-flex d-md-none" style="margin-left:-48px;"></v-spacer>
        <router-link
          :class="{'d-none': $route.path === '/'}"
          link to="/"
        >
          <img src="img/logo.png" alt="logo" class="nav_logo">
        </router-link>

        <v-spacer></v-spacer>

        <router-link class="d-none d-md-flex" link to="/works">
          <v-btn text>
          Works
          </v-btn>
        </router-link>
        <router-link class="d-none d-md-flex" link to="/video">
          <v-btn text>
          Video
          </v-btn>
        </router-link>
        <router-link class="d-none d-md-flex" link to="/information">
          <v-btn text>
          Information
          </v-btn>
        </router-link>
        <v-spacer class="d-none d-md-flex"></v-spacer>

        <v-btn class="d-none d-md-flex" text @click="Localetoja"
        :class="{ 'local_active': CheckLocale('ja') }">
        JP
        </v-btn>
        <v-btn class="d-none d-md-flex" text @click="Localetoen"
        :class="{ 'local_active': !CheckLocale('ja') }">
        EN
        </v-btn>
    </v-app-bar>
  </header>
</template>

<script>

export default {
  name: 'AppHeader',
  data: () => ({
    drawer: false,
  }),
  mounted: function () {
    window.addEventListener('resize', e => {
      if (!(e instanceof UIEvent)) {
        this.drawer = false
      }
    })
  },
  methods: {
    Localetoja () {
      this.$i18n.locale = 'ja'
      this.drawer = false
    },
    Localetoen () {
      this.$i18n.locale = 'en'
      this.drawer = false
    },
    CheckLocale (locale) {
      if (this.$i18n.locale === locale) {
        return true
      } else {
        return false
      }
    },
    CloseDrawer () {
      this.drawer = false
    }
  }
}
</script>

<style scoped>
.nav_logo {
  width:180px;
  margin:25px 0px 20px 20px ;
}

a {
  text-decoration:none;
}
.local_active {
  font-weight:900;
}

.v-app-bar {
  backdrop-filter: blur(10px);
}

#humberger {
  position: relative;
  height: 13px;
  width: 18px;
  display: inline-block;
  box-sizing: border-box;
}
#humberger div {
  position: absolute;
  left: 0;
  height: 3px;
  width: 18px;
  background-color: #999;
  border-radius: 2px;
  display: inline-block;
  box-sizing: border-box;
}
#humberger div:nth-of-type(1) {
  top: 0;
}
#humberger div:nth-of-type(2) {
  top: 5px;
}
#humberger div:nth-of-type(3) {
  bottom: 0;
}
</style>
